// @ts-check
import React from "react"
import themeClass from "./themeClass"
import { HtmlToReact } from "@components/html"

// Components for rendering a panel-styled teaser content

export const Title = ({ title }) =>
  title ? (
    <div className="panel-heading text-center text-lg">{title}</div>
  ) : null

export const BodyTitle = ({ title }) => <div className="text-bold">{title}</div>

export const BodyDescription = ({ description = null }) => description && <HtmlToReact preset="basic" html={description} />;

export const BodyButton = ({ buttonText, buttonStyle, teaserStyle = "" }) => {
  if (!buttonStyle && teaserStyle !== "default") {
    buttonStyle = teaserStyle
  }
  buttonStyle = themeClass("btn", buttonStyle)

  return (
    <button className={`btn btn-teaser gutter-top ${buttonStyle}`}>
      {buttonText}
    </button>
  )
}

export const BodyWrapper = ({ children }) =>
  React.Children.toArray(children).filter(o => o).length === 0 ? null : (
    <div className="panel-body">{children}</div>
  )

export const Body = ({
  Button = BodyButton,
  Description = BodyDescription,
  ...props
}) => {
  return (
    <BodyWrapper>
      {props.bodyTitle && <BodyTitle title={props.bodyTitle} />}
      {props.description && <Description {...props} />}
      {props.buttonText && <Button {...props} />}
    </BodyWrapper>
  )
}

export const BodyWithTitle = ({ title, ...props }) => (
  <Body {...props} bodyTitle={title} />
)

export const Panel = ({
  teaserStyle = null,
  className = "",
  panelClassName = "",
  children,
}) => {
  teaserStyle = themeClass("panel", teaserStyle !== "default" && teaserStyle)
  className = `content-teaser ${className}`
  return (
    <div className={className}>
      <div className={`panel panel-condensed ${teaserStyle} ${panelClassName}`}>
        {children}
      </div>
    </div>
  )
}
